import { render, staticRenderFns } from "./DropdownPlusSelectValue.vue?vue&type=template&id=a676df78&scoped=true&"
import script from "./DropdownPlusSelectValue.vue?vue&type=script&lang=js&"
export * from "./DropdownPlusSelectValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a676df78",
  null
  
)

export default component.exports